export function openQuickMenu({ state, action }) {
  return {
    ...state,
    quickMenuExpanded: {
      sku: action.sku,
      sectionId: action.sectionId,
    },
  };
}

export function closeQuickMenu({ state }) {
  return {
    ...state,
    quickMenuExpanded: null,
  };
}
